import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../sidebar";
import { ProgressContext } from "../ContextAPI";
import axios from "axios";
import { Box, Typography } from "@mui/material";
import ActionButtons from "./MaterialTopics/ActionButtons";
import { companyId } from "../../../utils/companyId";
import { api, get, post, put } from "../../../utils/api";
import SelectField from "../../Masters/SelectField";
import { generateCalenderYearRanges } from "../../../utils/generateYearRanges";
import SkipQuestionare from "../../Common/SkipQuestionare";
import InitialQuestionareSidebar from "../../../Layout/InitialQuestionareSidebar";
import { getQuestionareSubmitted } from "../../../utils/storage";

const ESGBaseline = () => {
  const navigate = useNavigate();
  const [isExist, setIsExist] = useState(false);
  const [year, setYear] = useState("");
  const companyDetails = getQuestionareSubmitted();

  const [errors, setErrors] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`${api}/esg-baseline/${companyId}`);
        console.log(response, "year");
        setYear(response?.data?.data?.year);
        setIsExist(true);
      } catch (err) {
        console.error("Error:", err);
      }
    };
    fetchData();
  }, []);

  const Move = async () => {
    try {
      if (year) {
        const data = { year, companyId, esg_baseline: true };
        const url = `/esg-baseline${isExist ? `/${companyId}` : ""}`;
        const method = isExist ? put : post;
        await method(url, data);
      }
      navigate(
        companyDetails?.questionareSubmitted
          ? "/preview"
          : "/environment/energy-management"
      );
    } catch (error) {
      setErrors(error?.message);
      console.error("Error:", error);
      // alert("There was an error submitting the data!");
    }
  };

  const Back = () => {
    navigate("/material-topics");
  };

  return (
    <Box sx={{ display: "flex", backgroundColor: "#EDEDED", height: "100vh" }}>
      <Box
        sx={{
          width: "25vw",
          // overflowY: "auto",
        }}
      >
        <InitialQuestionareSidebar />
      </Box>

      <Box
        sx={{
          width: "75vw",
          p: 2,
          mt: 3,
          height: "100vh",
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "80%",
            marginBottom: "1rem",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              padding: "10px 0px",
              borderRadius: "4px",
            }}
          >
            BASELINE YEAR
          </Typography>
          <SkipQuestionare />
        </div>

        <Box sx={{ width: "80%", height: "100%" }}>
          <Box sx={{ height: "75%", mt: "1.5rem" }}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                Define your ESG Baseline Year
              </Typography>
              <SelectField
                name={"question"}
                options={generateCalenderYearRanges(10)}
                value={year || "Tap to select"}
                handleChange={(e) => {
                  setYear(e.target.value);
                  setErrors("");
                }}
                borderColor={errors && "#D34040"}
                width="100%"
              />
              {errors && (
                <Typography variant="body2" color="#D34040">
                  {errors}
                </Typography>
              )}
            </Box>
          </Box>
          <ActionButtons
            Back={Back}
            Move={Move}
            disable={companyDetails?.questionareSubmitted}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ESGBaseline;
